import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React from 'react';
import CardItem from '../../atoms/Card';

const useStyles = makeStyles({
  root: {
    width: '1080px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    '@media only screen and (max-width: 1100px)': {
      width: '800px',
    },

    '@media only screen and (max-width: 768px)': {
      width: '100%',
    },
  },

  BoxList: {
    display: 'flex',
    flexWrap: 'wrap',

    '@media only screen and (max-width: 1100px)': {
      justifyContent: 'center',
    },

    '@media only screen and (max-width: 720px)': {
      flexDirection: 'column',
    },

    '@media only screen and (max-width: 460px)': {},
  },

  noSerach: {
    width: '100%',
  },

  card: {},
});

export default function CardMolecules(props) {
  const { cardList, handleContents } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.BoxList}>
        {cardList.map((i) => {
          return <CardItem handleClick={handleContents.bind(this, i)} key={i.id} data={i} className={classes.card}></CardItem>;
        })}
      </Box>
    </Box>
  );
}
